module.exports = __webpack_public_path__ + "static/media/driver.33f16799.svg";